<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Interface Configurations
              <router-link
                :to="{ name: 'InterfaceConfigurationAdd' }"
                class="btn ml-auto"
                v-if="actionCreate && organizationId != 1"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Interface Configurations</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header" v-if="!_.isEmpty(list.data) && is_loading == false">
            <div class="btn-toolbar pull-right" style="display: none">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools" style="display: none">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Audra Name -->
                  <div v-if="organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Audra Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.accountId"
                          :options="Object.keys(pre.audraName)"
                          :custom-label="(opt) => pre.audraName[opt]"
                          placeholder="Select Audra Name"
                          :searchable="true"
                          :multiple="false"
                          id="accountId"
                          v-bind:class="{
                            'has-error': errors.has('accountId'),
                          }"
                          name="accountId"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Description -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="description"
                      >Description</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="description"
                          name="description"
                          v-model="filter.description"
                          :class="{
                            'has-error': errors.has('description'),
                          }"
                          class="form-control"
                          placeholder="Description"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Interface Type -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="interface_type"
                      >Interface Type</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.interface_type"
                          :options="Object.keys(pre.interfaceTypes)"
                          :custom-label="(opt) => pre.interfaceTypes[opt]"
                          placeholder="Select Interface Type"
                          :searchable="true"
                          :multiple="false"
                          id="interface_type"
                          v-bind:class="{
                            'has-error': errors.has('interface_type'),
                          }"
                          name="interface_type"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Interface -->
                  <!-- <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="interface"
                      >Interface</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.interface"
                          :options="Object.keys(pre.interfaces)"
                          :custom-label="(opt) => pre.interfaces[opt]"
                          placeholder="Select Interface"
                          :searchable="true"
                          :multiple="false"
                          id="interface"
                          v-bind:class="{
                            'has-error': errors.has('interface'),
                          }"
                          name="interface"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div> -->
                  <div class="form-row">
                    <div class="col-md-3"></div>
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-2">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div
              v-if="!_.isEmpty(list.data) && is_loading == false"
              class="table-responsive-md"
            >
              <table class="table">
                <thead>
                  <tr>
                    <th v-if="userEmail === 'admin'">Audra</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Interface</th>
                    <th>IP Address</th>
                    <th>Protocol</th>
                    <th>Label</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="(val, index) in list.data">
                    <td v-if="userEmail === 'admin'">
                      {{ val.device_name }}
                    </td>

                    <td>
                      {{ val.interface_type ? val.interface_type.toUpperCase() : "" }}
                    </td>
                    <td>{{ val.description }}</td>
                    <td>{{ processInterface(val) }}</td>
                    <td>{{ val.network_addr }}</td>
                    <td>{{ processProtocol(val) }}</td>
                    <td>
                      {{ val.labeling ? val.labeling.toUpperCase() : "" }}
                    </td>
                    <td class="text-right">
                      <!-- <router-link v-if="actionView == true"
                      :to="{ name: 'InterfaceConfigurationShow', params: { id: val.id } }"
                      class="btn btn-info btn-sm m-2px">
                      <i class="fas fa-eye"></i>
                    </router-link> -->
                      <router-link
                        v-if="
                          (actionEdit == true &&
                            organizationId != 1 &&
                            val.is_edit == 1) ||
                          checkEditPermission(val)
                        "
                        :to="{
                          name: 'InterfaceConfigurationEdit',
                          params: { id: val.id },
                        }"
                        class="btn btn-edit"
                      >
                        <i class="icon-edit"></i>
                      </router-link>
                      <a
                        v-if="actionDelete == true && val.is_delete == 1"
                        class="btn btn-trash"
                        href="javascript:void(0)"
                        @click="
                          deleteObject(
                            val.id,
                            val.accountId,
                            val.interface_type,
                            val.interface,
                            val.description,
                            val.vlan_no,
                            index
                          )
                        "
                        ><i class="icon-trash"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mt-2 text-right d-block d-sm-none">
              Swipe <i class="icon-swipe"></i>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "InterfaceConfiguration",
  metaInfo: {
    title: "Interface Configurations | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: [],
      interfaceTypes: {
        Physical: "Physical",
        Bridge: "Bridge",
        Vlan: "Vlan",
        Loopback: "Loopback",
      },
      interfaces: ["eth2", "eth3", "eth4", "eth5"],
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/interface_configurations";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/interface_configurations"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      //   this.actionCreate = true;
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (
      id,
      accountId,
      interfaceType,
      natInterface,
      description,
      vlanNo,
      index
    ) {
      const _this = this;
      const delete_api_url = "/interface_configurations/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId,
                  interface_type: interfaceType,
                  interface: natInterface,
                  description: description,
                  vlanNo: vlanNo,
                },
              })
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                if (error.response.data.errors) {
                  _this.$swal.fire(
                    "Failed!",
                    error.response.data.errors.message,
                    "error"
                  );
                } else {
                  _this.$swal.fire("Failed!", "failed to delete.", "error");
                }
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/interface-configurations-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "interface_configurations.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },

    processInterface(val) {
      if (!val || val === "" || !val.interface) {
        return "Loopback";
      }
      const myhashmap = {
        eth0: "ETH-1",
        eth1: "ETH-2",
        eth2: "ETH-3",
        eth3: "ETH-4",
        eth4: "ETH-5",
        eth5: "ETH-6",
      };

      if (!val.interface) return "";
      if (val.interface == "br-lan") return "LAN";
      else if (val.interface == "br-lan2") return "LAN2";
      else if (val.interface == "br-lan3") return "LAN3";

      let allvalue = "";

      const processBridgeInterface = (value) => {
        const [key, alias] = value.split("|");
        const [interfaceBase, subInterface] = key.split(".");
        const formattedVal = subInterface
          ? `${myhashmap[interfaceBase] || interfaceBase}.${subInterface}`
          : myhashmap[interfaceBase] || interfaceBase;

        if (["ETH-1", "ETH-3", "ETH-4", "ETH-5", "ETH-6"].includes(alias)) {
          allvalue += `${formattedVal}, `;
        } else {
          allvalue += `${alias} (${formattedVal}), `;
        }
      };

      if (val.interface_type === "Bridge") {
        const interfaceAry = val.interface.split(",");
        if (interfaceAry.length > 1) {
          interfaceAry.forEach(processBridgeInterface);
          return allvalue.slice(0, -2);
        }
      } else if (val.interface_type === "Alias") {
        const [interfacePart] = val.interface.split("|");
        return interfacePart || "";
      } else if (val.interface_type === "Vlan") {
        const [value, alias] = val.interface.split("|");
        const finalAlias = alias && alias.trim() !== "" ? alias : value;
        return `${finalAlias}.${val.vlan_no ?? ""}`;
      }

      const [interfacePart, alias] = val.interface.split("|");
      return val.vlan_no
        ? alias || `${interfacePart}.${val.vlan_no}`
        : alias || interfacePart;
    },

    processProtocol(val) {
      if (!val.protocol) return "";

      if (val.is_dhcp == 1) {
        if (val.labeling === "LAN") {
          return val.protocol + " (DHCP Server)";
        } else {
          return val.protocol + " (DHCP Client)";
        }
      }

      return val.protocol;
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
